import { useContext, useState, useEffect } from 'react';
import { t } from 'i18next';
import { Box } from '@mui/material';
import Header, { VIEWS } from '../utils/Header';
import CircularIndeterminate from '../utils/Progress';
import ApiManager from '../../libs/ApiManager';
import ErrorMessageContext from '../context/ErrorMessageContext';
import FAQs from '../components/FAQs';
import EventManager from '../../libs/EventManager';

import '../../styles/FaqContainer.scss';

export default function FaqContainer ({
  faq,
  locale,
  onSignOut,
  onSubmit,
  onClose
}) {
  const { onError }  = useContext(ErrorMessageContext);
  const [isLoading, setLoading] = useState(false);
  const [faqArticles, setFaqArticles] = useState(null);
  const top = faq?.labels['top_faq'];
  const topFaqId = (Array.isArray(top) && top.length > 0) ? Number(top[0]) : null
  const faqs = faq?.labels['faq'];

  useEffect(() => {
    async function fetchArticles () {
      setLoading(true);
      try {
        const articles = await ApiManager.showArticles([...top, ...faqs].filter(Boolean), locale);
        setFaqArticles(articles);
      } catch (err) {
        onError(err);
      }
      setLoading(false);
    }
    if (Array.isArray(top) || Array.isArray(faqs)) {
      EventManager.clickSubcategory(faq?.id, topFaqId);
      fetchArticles();
    }
  }, [faq, locale]);

  function onFaqSubmit () {
    onSubmit(faq);
    EventManager.clickYes(topFaqId);
  }

  return <Box className='faq-container'>
    <Header title={t('header')} view={VIEWS.CATEGORY} onSignOut={onSignOut} onBack={onClose} />
    <Box className='faq-body'>
      <CircularIndeterminate show={isLoading} />
      <FAQs
          show={Array.isArray(faqArticles)}
          topFaq={topFaqId}
          faq={faq}
          articles={faqArticles}
          onSubmit={onFaqSubmit}
      />
    </Box>
  </Box>
}